import { render, staticRenderFns } from "./SingleDashboardView.vue?vue&type=template&id=60b3dc2c&scoped=true&"
import script from "./SingleDashboardView.vue?vue&type=script&lang=js&"
export * from "./SingleDashboardView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b3dc2c",
  null
  
)

export default component.exports